module.exports = __webpack_public_path__ + "15fa35ea2942225ce5cfc51d4597670f.MP3";